import { useMutation, useQueryClient } from "@tanstack/react-query";
import { patchJobAction } from "../../../clients/actions/patchJob.action";
import { useGlobalSnackbar } from "src/context/SnackbarContext";

export function usePatchJobPricing() {
  const { showSnackbar } = useGlobalSnackbar();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (variables: { jobId: string | number; payload: Record<string, unknown> }) =>
      patchJobAction(variables.jobId, variables.payload),
    onSuccess: (_data, variables) => {
      showSnackbar("Job pricing updated successfully", "success");
      queryClient.invalidateQueries({ queryKey: ["jobs"] });
      queryClient.invalidateQueries({ queryKey: ["job"] });
      queryClient.invalidateQueries({ queryKey: ["job", String(variables.jobId)] });
      queryClient.invalidateQueries({ queryKey: ["scopeOfWork"] });
    },
    onError: (error: any) => {
      showSnackbar(error?.response?.data?.message || "Failed to update job pricing", "error");
    },
  });
}
